import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Api } from "../services/interceptor";
import { QUERY_KEY } from "../services/queryEndPoint";
import type { IMatchDetails } from "../views/leaguesHome/tournaments/tournamentsDetails/matches/matchesDetails/types/matchDetails.d";

// Handles short share links like /BBU19-Vs-BSCU19/MO7XDEM by resolving the
// matchCode to a matchId and redirecting to the canonical match details route.
const MatchCodeRedirect: React.FC = () => {
  const { matchCode } = useParams<{ matchCode: string }>();

  const { data: match, isLoading, isError } = useQuery<IMatchDetails>({
    queryKey: [QUERY_KEY.getMatchInfo, "code", matchCode],
    enabled: !!matchCode,
    queryFn: async () => (await Api.get(`${QUERY_KEY.getMatchInfo}/code/${matchCode}`)).data,
  });

  if (!matchCode || isError) return <Navigate to="/" replace />;

  if (isLoading || !match) {
    return (
      <div className="myleagues-loading">
        <span>Loading match...</span>
      </div>
    );
  }

  return <Navigate to={`/matches-details/${match.matchId}`} replace />;
};

export default MatchCodeRedirect;
